import { oc } from "@orpc/contract";
import { z } from "zod";
import {
  PresignedUploadUrlInputSchema,
  PresignedUploadUrlResponseSchema,
} from "../shared/presignedUpload";

export const AgreementExtractSummarySchema = z.object({
  fileName: z.string(),
  uploadedAt: z.coerce.date(),
  uploadedBy: z.string().nullable(),
  agreementRowCount: z.number().int(),
  sourceRowCount: z.number().int(),
  skippedRowCount: z.number().int(),
  vendorPrefixes: z.array(z.string()),
});

export type AgreementExtractSummary = z.infer<
  typeof AgreementExtractSummarySchema
>;

export const agreementExtractContracts = {
  getUploadUrl: oc
    .input(PresignedUploadUrlInputSchema)
    .output(PresignedUploadUrlResponseSchema)
    .route({
      summary: "Get upload URL for a price agreement extract",
      description:
        "Returns a presigned URL for uploading the ERP's price-class agreement extract CSV (up to 100 MB). Call confirm upload afterwards to load it.",
    }),
  confirmUpload: oc
    .input(
      z.object({
        uploadKey: z.string().min(1),
        fileName: z.string().min(1).max(255),
      }),
    )
    .output(AgreementExtractSummarySchema)
    .route({
      summary: "Load an uploaded price agreement extract",
      description:
        "Reads the uploaded agreement extract CSV and replaces the organization's stored price-class agreements; returns row counts, skipped rows, and vendor prefixes.",
    }),
  getCurrent: oc
    .input(z.object({}))
    .output(
      z.object({ agreementExtract: AgreementExtractSummarySchema.nullable() }),
    )
    .route({
      method: "GET",
      summary: "Get the current price agreement extract",
      description:
        "Returns the summary of the loaded price-class agreement extract: file name, uploader, row counts, and vendor prefixes, or null if none is loaded.",
    }),
} as const;
